var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"login d-flex align-items-center justify-content-center pt-3 pb-3"},[_c('router-view'),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }